import React, { useEffect, useState } from "react";
import Dashboard from "../../components/Dashboard";
import Navbar from "../../components/Navbar";
import { useUser } from "../../context/user-context";
import { GoLock } from "react-icons/go";
import { SlArrowRight } from "react-icons/sl";
import { CiCreditCard1 } from "react-icons/ci";
import { LuBadgeCheck } from "react-icons/lu";
import { FaUsers } from "react-icons/fa";
import { TbMessage2Question } from "react-icons/tb";
import { useAuth } from "../../context/auth-context";
import AboutDeex from "./AboutDeex";
import EditProfile from "./EditProfile";
import Security from "./security/Security";
import Referral from "./Referral";
import SurveyCard from "../../components/survey/SurveyCard";
import BankDetails from "./banks/BankDetails";
import KYC from "./KYC";
import Kyc3Start from "./kyc3/Kyc3Start";
import Kyc3Onboarding from "./kyc3/Kyc3Onboarding";
import Kyc3Screens from "./kyc3/Kyc3Screens";
import Success from "./kyc3/Success";
import GenerateSuccess from "./generateStatement/GenerateSuccess";
import { receipt } from "../../assets/images";
import GenerateStatament from "./generateStatement/GenerateStatament";
import AddOtp from "../../components/phoneNumber/AddOtp";
import AddPhone from "../../components/phoneNumber/AddPhone";
import PhoneSuccess from "../../components/phoneNumber/Success";
import { useLocation, useNavigate } from "react-router-dom";
import useKycDetails from "../../hooks/useKycDetails";

const isStageComplete = (
  stage: { status?: string; data?: { status?: string } } | null | undefined
): boolean => {
  if (!stage) return false;
  const s = stage.status?.toLowerCase();
  const dataStatus = stage.data?.status?.toLowerCase();
  return s === "success" || s === "approved" || dataStatus === "approved";
};

const isStagePending = (
  stage: { status?: string } | null | undefined
): boolean => {
  if (!stage) return false;
  return stage.status?.toLowerCase() === "pending";
};

const Settings = () => {
  const { isOpen, userDetails } = useUser();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [openAbout, setOpenAbout] = useState<boolean>(false);
  const [openEditProfile, setOpenEditProfile] = useState<boolean>(false);
  const [openSecurity, setOpenSecurity] = useState<boolean>(false);
  const [openRefer, setOpenRefer] = useState<boolean>(false);
  const [openBankDetails, setOpenBankDetails] = useState<boolean>(false);
  const [openKyc, setOpenKyc] = useState<boolean>(false);
  // old kyc
  const [openStatement, setOpenStatement] = useState<boolean>(false);
  const [openSuccess, setOpenSuccess] = useState<boolean>(false);
  //kyc3
  const [openKyc3, setOpenKyc3] = useState<boolean>(false);
  const [openKyc3Start, setOpenKyc3Start] = useState<boolean>(false);
  const [openKyc3Screens, setOpenKyc3Screens] = useState<boolean>(false);
  const [kycSuccess, setKycSuccess] = useState<boolean>(false);
  const [openAddOtp, setOpenAddOtp] = useState(false);
  const [openPhoneSuccess, setOpenPhoneSuccess] = useState(false);
  const [openAddPhone, setOpenAddPhone] = useState(false);
  const [openPhoneCheck, setOpenPhoneCheck] = useState(false);
  const firstInitial = userDetails?.user.profile.firstName || "";
  const secondInitial = userDetails?.user.profile.lastName || "";

  const location = useLocation();
  const { data: kycDetailsData } = useKycDetails();
  const details = kycDetailsData?.kycDetails;
  const level1Complete = isStageComplete(details?.first_stage);
  const level2Complete = isStageComplete(details?.second_stage);
  const level3Complete = isStageComplete(details?.third_stage);
  const hasPending =
    isStagePending(details?.first_stage) ||
    isStagePending(details?.second_stage) ||
    isStagePending(details?.third_stage);
  const pendingLevel = details
    ? isStagePending(details.first_stage)
      ? 1
      : isStagePending(details.second_stage)
      ? 2
      : isStagePending(details.third_stage)
      ? 3
      : undefined
    : undefined;
  const openKycOnboardingFromState = location.state?.openKycOnboarding;

  useEffect(() => {
    if (openKycOnboardingFromState) {
      navigate("/kyc-verification", { replace: true, state: {} });
    }
  }, [openKycOnboardingFromState, navigate]);

  return (
    <div className="lgss:flex font-manrope  lgss:flex-row h-screen lgss:h-screen bg-[#E7EBEE]   dark:bg-[#13181B]">
      <Dashboard />
      <div
        className={
          isOpen
            ? "w-full h-full pt-0  font-manrope overflow-hidden lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]"
            : "w-full h-full pt-0  font-manrope overflow-auto lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]"
        }
      >
        <Navbar />
        <div className="w-full mt-16 lgss:mt-28 pb-16 ">
          <div className="w-full max-w-[720px] mx-auto px-4 mds:px-8 flex flex-col">
            <div className="flex justify-center   flex-row items-start gap-8">
              <div className="w-[90px] lgss:w-[121px] lgss:h-[121px] h-[90px] rounded-full bg-[#D4EBFD] flex justify-center items-center font-sora font-semibold text-secondary_button text-[32px]">
                {firstInitial.charAt(0)}
                {secondInitial.charAt(0)}
              </div>
              <div className="flex flex-col items-start">
                <h4 className="font-sora lgss:text-[20px] text-[16px] mds:text-[18px] mt-2 font-semibold text-gray-900 dark:text-gray-200  ">
                  {firstInitial} {secondInitial}
                </h4>
                <h4 className=" text-[16px]  text-gray-500 dark:text-gray-400 ">
                  {userDetails?.user.email.address}
                </h4>
                <h4 className=" text-[14px] italic font-medium  text-gray-500 dark:text-gray-400 ">
                  @{userDetails?.user.profile.username}
                </h4>
                <button
                  onClick={() => setOpenEditProfile(true)}
                  className="p-3 bg-[#D4EBFD] flex justify-center items-center font-semibold rounded-md mt-4 text-secondary_button text-[11px]"
                >
                  Edit profile
                </button>
              </div>
            </div>
            {/* Renders only when the admin gave the survey the SETTINGS placement. */}
            <SurveyCard placement="SETTINGS" className="mt-10" />
            <div className="w-full mt-16">
              <h4 className="font-sora text-left text-[16px] mt-2 font-semibold text-gray-900 dark:text-gray-200  ">
                Settings
              </h4>
              <div className="bg-white dark:bg-[#1F2C36] rounded-xl mt-4 p-4">
                <div
                  onClick={() => setOpenSecurity(true)}
                  className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-700  items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <GoLock />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        Security
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Setup 2FA, Change PIN and password
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
                <div
                  onClick={() => setOpenStatement(true)}
                  className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-700  items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <img
                        src={receipt}
                        className="w-[18px] h-[18px] object-cover"
                        alt=""
                      />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        Generate statement
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Get your statement of account
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
                <div
                  onClick={() => setOpenBankDetails(true)}
                  className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-700  items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <CiCreditCard1 />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        Saved Accounts
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Modify financial details
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
                <div
                  onClick={() => navigate("/kyc-verification")}
                  className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-700 items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <LuBadgeCheck />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        KYC Verification{" "}
                      </h4>
                      <div className="flex w-full justify-start items-center mt-1 gap-2">
                        {hasPending ? (
                          <div className="px-2 py-1 bg-[#FDEDDB] dark:bg-[#F28A0F]/20 rounded-lg text-[9px] font-semibold text-[#F28A0F]">
                            Pending - Level {pendingLevel ?? 1}
                          </div>
                        ) : level3Complete ? (
                          <div className="px-2 py-1 bg-[#0D851D] dark:bg-[#0D851D]/30 rounded-lg text-[9px] font-semibold dark:text-green-300 text-[#DAF1DD]">
                            Verified - Level 3
                          </div>
                        ) : level2Complete ? (
                          <div className="px-2 py-1 bg-[#0D851D] dark:bg-[#0D851D]/30 rounded-lg text-[9px] font-semibold dark:text-green-300 text-[#DAF1DD]">
                            Verified - Level 2
                          </div>
                        ) : level1Complete ? (
                          <div className="px-2 py-1 bg-[#0D851D] dark:bg-[#0D851D]/30 rounded-lg text-[9px] font-semibold dark:text-green-300 text-[#DAF1DD]">
                            Verified - Level 1
                          </div>
                        ) : (
                          <h4 className="text-gray-500 text-[13px]">
                            Verify account
                          </h4>
                        )}
                      </div>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
                <div
                  onClick={() => setOpenRefer(true)}
                  className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-700  items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <FaUsers />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        Refer & Earn
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Refer friends and earn commission
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
                <div
                  onClick={() => setOpenAbout(true)}
                  className="flex justify-between py-5  items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center bg-[#D4EBFD] text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <TbMessage2Question />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        About DeeX
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        About, Contact and Privacy Policy
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
              </div>
              <button
                onClick={logout}
                className="w-full py-4 bg-transparent border border-[#D92B2B] flex justify-center items-center font-medium rounded-xl mt-10 text-[#D92B2B] text-[16px]"
              >
                Log out
              </button>
            </div>
          </div>
        </div>
        {openAbout && <AboutDeex setOpenAbout={setOpenAbout} />}
        {openEditProfile && (
          <EditProfile
            setOpenEditProfile={setOpenEditProfile}
            setOpenAddPhone={setOpenAddPhone}
          />
        )}
        {openSecurity && (
          <Security
            setOpenSecurity={setOpenSecurity}
            setOpenAddPhone={setOpenAddPhone}
          />
        )}
        {openRefer && <Referral setOpenRefer={setOpenRefer} />}
        {openBankDetails && (
          <BankDetails setOpenBankDetails={setOpenBankDetails} />
        )}
        {openKyc && (
          <KYC
            setOpenKyc={setOpenKyc}
            setOpenKyc3={setOpenKyc3}
            setOpenBankDetails={setOpenBankDetails}
            setOpenAddPhone={setOpenAddPhone}
          />
        )}
        {openKyc3 && (
          <Kyc3Start
            setOpenKyc={setOpenKyc}
            setOpenKyc3={setOpenKyc3}
            setOpenKyc3Start={setOpenKyc3Start}
          />
        )}
        {openKyc3Start && (
          <Kyc3Onboarding
            setOpenKyc3Start={setOpenKyc3Start}
            setOpenKyc3={setOpenKyc3}
            setOpenKyc3Screens={setOpenKyc3Screens}
          />
        )}
        {openKyc3Screens && (
          <Kyc3Screens
            setOpenKyc3Start={setOpenKyc3Start}
            setOpenKyc3Screens={setOpenKyc3Screens}
            setKycSuccess={setKycSuccess}
          />
        )}
        {kycSuccess && <Success setKycSuccess={setKycSuccess} />}
        {openStatement && (
          <GenerateStatament
            setOpenStatement={setOpenStatement}
            setOpenSuccess={setOpenSuccess}
          />
        )}
        {openSuccess && <GenerateSuccess setOpenSuccess={setOpenSuccess} />}

        {openAddPhone && (
          <AddPhone
            setOpenAddPhone={setOpenAddPhone}
            setOpenAddOtp={setOpenAddOtp}
            setOpenPhoneCheck={setOpenPhoneCheck}
          />
        )}
        {openAddOtp && (
          <AddOtp
            setOpenAddOtp={setOpenAddOtp}
            setOpenSuccess={setOpenPhoneSuccess}
          />
        )}
        {openPhoneSuccess && (
          <PhoneSuccess
            setOpenSuccess={setOpenPhoneSuccess}
            setOpenPhoneCheck={setOpenPhoneCheck}
          />
        )}
      </div>
    </div>
  );
};

export default Settings;
